/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDestinationRequestDestinationMetadata
 */
export interface UpdateDestinationRequestDestinationMetadata {
    /**
     * Webhook URL
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    url?: string;
    /**
     * Additional headers to add when Ampersand sends a webhook message
     * @type {{ [key: string]: string; }}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    headers?: { [key: string]: string; } | null;
    /**
     * The AWS region where the Kinesis or S3 destination is hosted.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    region?: string;
    /**
     * The name of the Kinesis stream to send events to.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    streamName?: string;
    /**
     * The endpoint URL for the `kinesis` stream, or the optional custom endpoint URL for the `sqs` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    endpointUrl?: string;
    /**
     * The template for the partition key (a JMESPath template). Used by `kinesis`.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    partitionKeyTemplate?: string;
    /**
     * The name of the S3 bucket to write objects to.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    bucket?: string;
    /**
     * The template for the S3 object key to use when writing objects (a JMESPath template). If omitted, the key defaults to the message timestamp followed by the message ID.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    keyTemplate?: string;
    /**
     * The S3 storage class for written objects. Defaults to STANDARD. Common values include STANDARD, STANDARD_IA, ONEZONE_IA, INTELLIGENT_TIERING, GLACIER, GLACIER_IR, and DEEP_ARCHIVE.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    storageClass?: string;
    /**
     * The username for the `clickhouse` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    username?: string;
    /**
     * The destination table name (`clickhouse`, `snowflake`, `redshift`).
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    tableName?: string;
    /**
     * The database name for the `clickhouse` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    database?: string;
    /**
     * The Snowflake account identifier for the `snowflake` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    accountIdentifier?: string;
    /**
     * The user ID for the `snowflake` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    userId?: string;
    /**
     * The database name (`snowflake`, `redshift`).
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    dbName?: string;
    /**
     * The schema name (`snowflake`, `redshift`).
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    schemaName?: string;
    /**
     * The Google Cloud project ID (`bigquery`, `pubsub`). Required for `pubsub`.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    projectId?: string;
    /**
     * The BigQuery dataset ID for the `bigquery` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    datasetId?: string;
    /**
     * The BigQuery table ID for the `bigquery` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    tableId?: string;
    /**
     * The Redshift Serverless workgroup name for the `redshift` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    workgroupName?: string;
    /**
     * The Redshift provisioned cluster identifier for the `redshift` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    clusterIdentifier?: string;
    /**
     * The database user for the `redshift` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    dbUser?: string;
    /**
     * The storage account name for the `azureblob` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    account?: string;
    /**
     * The blob container name for the `azureblob` destination.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    container?: string;
    /**
     * The SQS queue URL for the `sqs` destination. Required for `sqs`.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    queueUrl?: string;
    /**
     * The Pub/Sub topic ID for the `pubsub` destination. Required for `pubsub`.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    topicId?: string;
    /**
     * The AMQP server URL for the `rabbitmq` destination. Required for `rabbitmq`.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    serverUrl?: string;
    /**
     * The exchange to publish to for the `rabbitmq` destination. Required for `rabbitmq`.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    exchange?: string;
    /**
     * Whether to connect over TLS. Optional for the `rabbitmq` destination.
     * @type {boolean}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    tls?: boolean;
    /**
     * The queue or topic name for the `azureservicebus` destination. Required for `azureservicebus`.
     * @type {string}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    name?: string;
    /**
     * For warehouse destinations, rows to buffer before flushing a batch (default 1000).
     * @type {number}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    batchSize?: number;
    /**
     * For warehouse destinations, max seconds before flushing a batch (default 30).
     * @type {number}
     * @memberof UpdateDestinationRequestDestinationMetadata
     */
    maxWaitSecs?: number;
}

/**
 * Check if a given object implements the UpdateDestinationRequestDestinationMetadata interface.
 */
export function instanceOfUpdateDestinationRequestDestinationMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateDestinationRequestDestinationMetadataFromJSON(json: any): UpdateDestinationRequestDestinationMetadata {
    return UpdateDestinationRequestDestinationMetadataFromJSONTyped(json, false);
}

export function UpdateDestinationRequestDestinationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDestinationRequestDestinationMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'headers': !exists(json, 'headers') ? undefined : json['headers'],
        'region': !exists(json, 'region') ? undefined : json['region'],
        'streamName': !exists(json, 'streamName') ? undefined : json['streamName'],
        'endpointUrl': !exists(json, 'endpointUrl') ? undefined : json['endpointUrl'],
        'partitionKeyTemplate': !exists(json, 'partitionKeyTemplate') ? undefined : json['partitionKeyTemplate'],
        'bucket': !exists(json, 'bucket') ? undefined : json['bucket'],
        'keyTemplate': !exists(json, 'keyTemplate') ? undefined : json['keyTemplate'],
        'storageClass': !exists(json, 'storageClass') ? undefined : json['storageClass'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'tableName': !exists(json, 'tableName') ? undefined : json['tableName'],
        'database': !exists(json, 'database') ? undefined : json['database'],
        'accountIdentifier': !exists(json, 'accountIdentifier') ? undefined : json['accountIdentifier'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'dbName': !exists(json, 'dbName') ? undefined : json['dbName'],
        'schemaName': !exists(json, 'schemaName') ? undefined : json['schemaName'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'datasetId': !exists(json, 'datasetId') ? undefined : json['datasetId'],
        'tableId': !exists(json, 'tableId') ? undefined : json['tableId'],
        'workgroupName': !exists(json, 'workgroupName') ? undefined : json['workgroupName'],
        'clusterIdentifier': !exists(json, 'clusterIdentifier') ? undefined : json['clusterIdentifier'],
        'dbUser': !exists(json, 'dbUser') ? undefined : json['dbUser'],
        'account': !exists(json, 'account') ? undefined : json['account'],
        'container': !exists(json, 'container') ? undefined : json['container'],
        'queueUrl': !exists(json, 'queueUrl') ? undefined : json['queueUrl'],
        'topicId': !exists(json, 'topicId') ? undefined : json['topicId'],
        'serverUrl': !exists(json, 'serverUrl') ? undefined : json['serverUrl'],
        'exchange': !exists(json, 'exchange') ? undefined : json['exchange'],
        'tls': !exists(json, 'tls') ? undefined : json['tls'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'batchSize': !exists(json, 'batchSize') ? undefined : json['batchSize'],
        'maxWaitSecs': !exists(json, 'maxWaitSecs') ? undefined : json['maxWaitSecs'],
    };
}

export function UpdateDestinationRequestDestinationMetadataToJSON(value?: UpdateDestinationRequestDestinationMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'headers': value.headers,
        'region': value.region,
        'streamName': value.streamName,
        'endpointUrl': value.endpointUrl,
        'partitionKeyTemplate': value.partitionKeyTemplate,
        'bucket': value.bucket,
        'keyTemplate': value.keyTemplate,
        'storageClass': value.storageClass,
        'username': value.username,
        'tableName': value.tableName,
        'database': value.database,
        'accountIdentifier': value.accountIdentifier,
        'userId': value.userId,
        'dbName': value.dbName,
        'schemaName': value.schemaName,
        'projectId': value.projectId,
        'datasetId': value.datasetId,
        'tableId': value.tableId,
        'workgroupName': value.workgroupName,
        'clusterIdentifier': value.clusterIdentifier,
        'dbUser': value.dbUser,
        'account': value.account,
        'container': value.container,
        'queueUrl': value.queueUrl,
        'topicId': value.topicId,
        'serverUrl': value.serverUrl,
        'exchange': value.exchange,
        'tls': value.tls,
        'name': value.name,
        'batchSize': value.batchSize,
        'maxWaitSecs': value.maxWaitSecs,
    };
}

